import L from 'leaflet';
import turfBearing from '@turf/bearing';

function toDegMinDisplay(val: number, isLat: boolean): string {
    const absVal = Math.abs(val);
    const deg = Math.floor(absVal);
    const min = (absVal - deg) * 60;
    const dir = isLat ? (val >= 0 ? 'N' : 'S') : (val >= 0 ? 'E' : 'W');
    
    // Format: 36° 50.12' S
    return `${deg}° ${min.toFixed(3)}' ${dir}`;
}

export function formatCoordinate(val: number, isLat: boolean, format: 'deg-min' | 'deg-dec'): string {
    if (format === 'deg-dec') {
        return val.toFixed(5);
    } else {
        return toDegMinDisplay(val, isLat);
    }
}

export function calculateDestination(start: L.LatLng, bearing: number, distanceNM: number): L.LatLng {
    const R = 3440.065; // Earth radius in Nautical Miles
    const brng = bearing * Math.PI / 180;
    const d = distanceNM;
    const lat1 = start.lat * Math.PI / 180;
    const lon1 = start.lng * Math.PI / 180;

    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d / R) +
        Math.cos(lat1) * Math.sin(d / R) * Math.cos(brng));
    const lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(d / R) * Math.cos(lat1),
        Math.cos(d / R) - Math.sin(lat1) * Math.sin(lat2));

    return new L.LatLng(lat2 * 180 / Math.PI, lon2 * 180 / Math.PI);
}

export function calculateBearing(start: L.LatLng, end: L.LatLng): number {
    const bearing = turfBearing([start.lng, start.lat], [end.lng, end.lat]);
    return bearing < 0 ? bearing + 360 : bearing;
}

export function toDegMin(val: number): { deg: number; min: number } {
    const absVal = Math.abs(val);
    const deg = Math.floor(absVal);
    const min = (absVal - deg) * 60;
    return {deg: val < 0 ? -deg : deg, min};
}

export function fromDegMin(deg: number, min: number): number {
    const absDeg = Math.abs(deg);
    const val = absDeg + (min / 60);
    const isNegative = deg < 0 || (deg === 0 && 1 / deg === -Infinity);
    return isNegative ? -val : val;
}